import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import Container from '../components/Container'
import ContactForm from '../components/ContactForm'
import SEO from '../components/SEO'
import PageBody from '../components/PageBody'

const Contact = ({ data }) => {
  const postNode = {
    title: `Contact - ${config.siteTitle}`,
  }
  const snippet = data.snippet.body
  return (
    <div>
      <Helmet>
        <title>{`Contact - ${config.siteTitle}`}</title>
      </Helmet>

      <SEO postNode={postNode} pagePath="contact" customTitle />

      <Container>
        <PageBody body={snippet} />
        <ContactForm />
      </Container>
    </div>
  )
}

export const query = graphql`
  query getContactPage {
    snippet: contentfulPageSnippet(itentifier: { eq: "contact" }) {
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js